import { useEffect, useState } from 'react'
import { apiClient } from '../../../api/ApiClient'
import { ApiShippingAddress } from '../../../api/quotes/types/ApiShippingAddress'
import { AuthTokenFactory } from '../../../auth/AuthTokenFactory'

export function useShippingAddresses(chatId: string): {
  addresses: ApiShippingAddress[]
  defaultAddress: ApiShippingAddress | null
  loading: boolean
} {
  const [addresses, setAddresses] = useState<ApiShippingAddress[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const customerId = AuthTokenFactory.getCustomerId()
    if (!customerId) return

    setLoading(true)

    apiClient.quotes.getShippingAddresses({ customerId }).then((result) => {
      setAddresses(result)
      setLoading(false)
    })
  }, [chatId])

  const defaultAddress = addresses.find((a) => a.default) ?? addresses[0] ?? null

  return { addresses, defaultAddress, loading }
}
